import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionHeadProps {
  eyebrow?: string;
  title: ReactNode;
  className?: string;
  align?: "left" | "center";
}

/**
 * `<h1>`: in ogni pagina che la usa (Contatti, Galleria, Menù, La Cantina,
 * Privacy, Cookie, l'intro di Il Ristorante, il form di Prenota) è l'unico
 * titolo di pagina — prima era `<h2>` e queste 7 pagine restavano senza
 * nessun h1 (trovato in audit SEO, vedi decisions.md). Home e la conferma di
 * Prenota hanno il proprio h1 altrove e non passano da qui.
 */
export function SectionHead({ eyebrow, title, className, align = "left" }: SectionHeadProps) {
  return (
    <div className={cn("mb-12 max-w-[720px]", align === "center" && "mx-auto text-center", className)}>
      {eyebrow ? <p className="eyebrow mb-3.5 block">{eyebrow}</p> : null}
      <h1 className="font-display text-[40px] leading-[1.02] font-medium tracking-[-0.015em] md:text-[56px]">
        {title}
      </h1>
    </div>
  );
}
